// extracted by mini-css-extract-plugin
export default {"mainTable":"Static_mainTable__BB3jy"};